module.exports = __webpack_public_path__ + "img/workshop_header_bg_desktop.6979765c.svg";